import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed2460fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  for: "address",
  class: "input-label"
}
const _hoisted_2 = { class: "input-container" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "resolved-address"
}
const _hoisted_5 = {
  key: 1,
  class: "absolute-box"
}
const _hoisted_6 = {
  key: 2,
  class: "absolute-box"
}
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}

import { isAddress } from '@ethersproject/address';
import { XCircleIcon } from '@heroicons/vue/20/solid';
import { debounce } from 'lodash';
import { onMounted, ref, watch } from 'vue';
import Spinner from '@/components/Spinner.vue';
import Tooltip from '@/components/Tooltip.vue';
import { formatAddress, resolveAddressFromBadges, resolveENSFromBadges } from '@/lib/address';

interface RecipientAddressInputProps {
  initialAddress: string | null;
  required?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientAddressInput',
  props: {
    initialAddress: {},
    required: { type: Boolean }
  },
  emits: ['onAddressChanged', 'checkingAddress'],
  setup(__props: any, { emit }) {

const props = __props;




const inputValue = ref(props.initialAddress || '');
const addressError = ref('');
const resolvedAddress = ref<string | null>('');
const isEnsAddress = ref(false);
const isLoading = ref(false);
const firstPass = ref(true);

onMounted(() => {
  if (firstPass.value && inputValue.value) {
    processInput();
    firstPass.value = false;
    return;
  }

  if (firstPass.value) {
    firstPass.value = false;
    return;
  }

  processInput();
  firstPass.value = false;
});

watch(inputValue, () => {
  addressError.value = '';
  processInput();
});

const clearAddress = () => {
  inputValue.value = '';
  resolvedAddress.value = '';
  isEnsAddress.value = false;
  emit('onAddressChanged', null);
};

const processInput = debounce(async () => {
  isLoading.value = true;
  addressError.value = '';
  resolvedAddress.value = '';
  isEnsAddress.value = false;
  emit('onAddressChanged', null);
  emit('checkingAddress');

  if (!inputValue.value) {
    isLoading.value = false;

    if (props.required) {
      addressError.value = 'A valid recipient address is required';
    }

    return;
  }

  resolvedAddress.value = inputValue.value;

  if (isAddress(inputValue.value)) {
    const ens = await resolveENSFromBadges(inputValue.value);

    if (ens) {
      inputValue.value = ens;
      return;
    }

    resolvedAddress.value = inputValue.value;
    isLoading.value = false;
    emit('onAddressChanged', resolvedAddress.value);
    return;
  }

  // If not ENS or address
  if (!inputValue.value.includes('.')) {
    addressError.value = 'Not a valid address';
    isLoading.value = false;
    emit('onAddressChanged', null);
  }

  const address = await resolveAddressFromBadges(inputValue.value);

  if (address) {
    resolvedAddress.value = address;
    isEnsAddress.value = true;
    addressError.value = '';
    isLoading.value = false;
    emit('onAddressChanged', resolvedAddress.value);
    return;
  }

  addressError.value = 'ENS doesn’t resolve to a valid address';
  isLoading.value = false;
  emit('onAddressChanged', null);
}, 400);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("span", null, "ETH address " + _toDisplayString(_ctx.required ? '' : '(optional)'), 1),
      _createVNode(Tooltip, {
        header: "Recipient ETH Address",
        content: 
          _ctx.required
            ? 'Provide the Ethereum wallet address that is part of the allow list and where the item will be sent to directly.'
            : 'You can optionally provide an Ethereum wallet address where the item will be sent to directly.'
        
      }, null, 8, ["content"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        onFocusout: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(processInput) && _unref(processInput)(...args))),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
        class: _normalizeClass([
          'text-input',
          addressError.value ? 'error' : '',
          isEnsAddress.value ? 'has-resolved-address' : '',
        ]),
        disabled: isLoading.value,
        name: "recipientWalletAddress",
        type: "text",
        placeholder: "example.eth"
      }, null, 42, _hoisted_3), [
        [_vModelText, inputValue.value]
      ]),
      (isEnsAddress.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(formatAddress)(resolvedAddress.value)), 1))
        : _createCommentVNode("", true),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(Spinner)
          ]))
        : (resolvedAddress.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(XCircleIcon), {
                class: "close-icon",
                onClick: clearAddress
              })
            ]))
          : _createCommentVNode("", true)
    ]),
    (addressError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(addressError.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})